// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer[data-v-4edffc3e]{text-align:center;font-size:13px;line-height:1.42857143;padding-bottom:10px;margin-top:30px}.footer[data-v-4edffc3e],.footer a[data-v-4edffc3e]{color:rgba(0,0,0,.5)}.footer a[data-v-4edffc3e]{background:transparent;text-decoration:none;-webkit-tap-highlight-color:transparent}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
